<template>
    <div class="col-md-7 border-0 ">
        <div class="ibox dasboard_graph">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                <div class="clearfix">
                    <div class="left_container">
                        <ul class="title_list">
                            <li class="title-text">List of Approved Holidays</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="ibox-content pt-0">
                <div class="employee-table-wrapper table-sticky-height">
                    <table class="employee-list-table dataTable table-overflow table-sticky">
                        <thead style="">
                            <tr class="table-head">
                                <td>From</td>
                                <td class="text-right">To</td>
                                <td class="text-right">Title of Approved Holiday</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(holiday, n) in paginatedData">
                                <tr class="table-row hover-bg">
                                    <td>{{ formatdate2(holiday.holiday_date) }}</td>
                                    <td>{{ formatdate2(holiday.holiday_date) }}</td>
                                    <td>{{ holiday.comment }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <div v-if="holidays.length == 0" class="list-no-data">
                        No records found.
                    </div>
                </div>

                <!-- Abdullah after live added pagination  -->
                <!-- Pagination -->
                <div v-if="holidays.length > 0" class="row py-2 no-margin">
                    <div class="col-md-12 p-0 no-margin">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                                <b-form-select v-model="length" :options="length_options" @change="currentPage = 1"></b-form-select>
                            </li>
                            <li class="page-item disabled m-2">per page. Total {{ holidays.length }} records found.</li>
                        </ul>
                        <b-pagination-nav
                            v-model="currentPage"
                            :number-of-pages="totalPages"
                            base-url="#"
                            prev-text="Previous"
                            next-text="Next"
                            first-number
                            last-number
                        ></b-pagination-nav>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default{
        mounted() {},
        props: ['holidays'],
        components: {},
        data(){
            return {
                currentPage: 1,
                length: 10,
                length_options: [
                    { value: 10, text: "10" },
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                ],
            }
        },
        methods:{
            formatdate2: function(x){
                return moment(x).format('D MMMM YYYY');
            },
            formatdate: function(x){
                return moment(x).format('MMMM YYYY');
            },
        },
        computed: {
            totalPages(){
                return Math.ceil(this.holidays.length / this.length) || 1;
            },
            paginatedData(){
                const start = (this.currentPage - 1) * this.length;
                const end = start + this.length;
                return this.holidays.slice(start, end);
            }
        },
        created: function(){},
    }
</script>
